import BaseInputValidator from "../../../common/input-validators/BaseInputValidator";
import Field from "../../../../model/configurator/Field";
import React from "react";

interface SelfProps {
    renderField: (field: any, additionalProps?: object, validator?: BaseInputValidator | undefined) => any;
    fields: { [key: string]: Field };
    equivalentInStandardApartments: number;
    readonly?: boolean;
}

export class ApartmentNumbersTable extends React.Component<SelfProps> {
    renderField = (field: any, additionalProps?: object, validator?: BaseInputValidator | undefined) => {
        const props = this.props.readonly ? { ...additionalProps, readonly: true, description: '' } : additionalProps;
        return this.props.renderField(field, props, validator)
    }
    render() {
        return <>
            <table className={this.props.readonly ? `step-stripped-table centered-readonly-field` : `step-stripped-table`}>
                <thead className={this.props.readonly ? 'no-top-border' : ''}>
                    <tr>
                        <th>{__('Appt type')}</th>
                        <th>{__('Number')}</th>
                    </tr>
                </thead>
                <tbody className={`input-center-text`}>
                    <tr>
                        <td>{__('Studio')}</td>
                        <td>{this.renderField(this.props.fields.apartmentsStudio, { noLabel: true })}</td>
                    </tr>
                    <tr>
                        <td>{__('T1 1 Room')}</td>
                        <td>{this.renderField(this.props.fields.apartmentsT1Room, { noLabel: true })}</td>
                    </tr>
                    <tr>
                        <td>{__('T2 2 Room')}</td>
                        <td>{this.renderField(this.props.fields.apartmentsT2Room, { noLabel: true })}</td>
                    </tr>
                    <tr>
                        <td>{__('T3 3 Room')}</td>
                        <td>{this.renderField(this.props.fields.apartmentsT3Room, { noLabel: true })}</td>
                    </tr>
                    <tr>
                        <td>{__('T4 4 Room')}</td>
                        <td>{this.renderField(this.props.fields.apartmentsT4Room, { noLabel: true })}</td>
                    </tr>
                    <tr>
                        <td>{__('T5 5 Room')}</td>
                        <td>{this.renderField(this.props.fields.apartmentsT5Room, { noLabel: true })}</td>
                    </tr>
                    <tr>
                        <td>{__('T6 6 Room')}</td>
                        <td>{this.renderField(this.props.fields.apartmentsT6Room, { noLabel: true })}</td>
                    </tr>
                    <tr className={`border-top`}>
                        <td className={`text-cell`}>{__('Equivalent in standard apartments')}</td>
                        <td className={`text-cell`}>{this.props.equivalentInStandardApartments}</td>
                    </tr>
                </tbody>
            </table>
        </>
    }
}